/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	'use strict';
	/*globals Tc, debug, google */

	/**
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class Google Maps
	 * @extends Tc.Module
	 *
	 */
	Tc.Module.GoogleMaps = Tc.Module.extend({

		channelId: 'googleMaps',
		statusMapLoaded: 'googleMapLoaded',
		drawMapLocations: 'googleMapDrawLocations',
		statusShowMap: 'googleMapShowMap',
		markerPinImageHeight: 30,
		DEFAULT_LAT: 47.378388,
		DEFAULT_LNG: 8.539193,
		DEFAULT_ZOOM: 16,

		init: function($ctx, sandbox, modId) {
			this.$ctx = $ctx;
			this.mapCenterLat = (this.$ctx.data('centerlat')) ? parseFloat(this.$ctx.data('centerlat')) : this.DEFAULT_LAT;
			this.mapCenterLng = (this.$ctx.data('centerlng')) ? parseFloat(this.$ctx.data('centerlng')) : this.DEFAULT_LNG;
			this.mapZoom = (this.$ctx.data('mapzoom')) ? parseInt(this.$ctx.data('mapzoom')) : this.DEFAULT_ZOOM;
			this.markerPinImage = this.$ctx.data('pinurl');
			this.mapmarkers = [];
			this.locations = this.$ctx.data('locations');
			this.lazyLoad = this.$ctx.data('lazyload') ? true : false;
			if(this.markerPinImage){
				$('<img>').on('load', $.proxy(this.setPinImageHeight, this)).attr('src', this.markerPinImage);
			}

			this.initialiazed = false;
			this._super($ctx, sandbox, modId);
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {

			if( !this.lazyLoad ) {
				this.initGoolgeMapModule();
			}
			callback();
		},

		setPinImageHeight: function(event){
			this.markerPinImageHeight = event.target.height;
		},

		loadMap: function() {
			Tc.Module.GoogleMaps.globalMapLoaded = $.proxy(this.mapLoaded, this);
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&' +
				'key=AIzaSyCZ7XcxAZ9vixukf6fm5EaUvAAfjzdw7Zw&' + // pragma: allowlist-secret
				'callback=Tc.Module.GoogleMaps.globalMapLoaded';
			document.body.appendChild(script);
		},

		mapLoaded: function(){
			var mod = this;

			mod.fire(mod.statusMapLoaded, {}, [mod.channelId]);

			mod.initializeMap();
		},

		initializeMap: function(){
			var mod = this;

			mod.mapOptions = {
				center: new google.maps.LatLng(mod.mapCenterLat, mod.mapCenterLng),
				zoom: mod.mapZoom
			};

			mod.map = new google.maps.Map(document.getElementById(mod.$ctx.attr('id')), mod.mapOptions);
			mod.geocoder = new google.maps.Geocoder();
			mod.mapInfoWindow = new google.maps.InfoWindow({pixelOffset: new google.maps.Size(0, -this.markerPinImageHeight) });
			this.drawMapMarkers();
		},

		drawMapMarkers: function() {
			var i,
				locationData,
				length,
				latlng,
				mod = this;
			this.createGoogleCnt = this.createGoogleCnt || 0;

			if( typeof google !== "undefined" ) {
				mod.clearMapMarkers();
				if(mod.locations){
					for(i = 0, length = mod.locations.length; i < length; i++){
						locationData = mod.locations[i];
						if( locationData.locationlat !== '' && locationData.locationlng !== '' ) {
							latlng = new google.maps.LatLng( parseFloat(locationData.locationlat), parseFloat(locationData.locationlng) );
							mod.drawLocation( latlng, locationData.title, locationData.description );
						}
						else if( locationData.address && locationData.address !== '' ) {
							mod.geolockup( locationData );
						}

					}
				}
			} else {
				if (this.createGoogleCnt < 10) {
					this.createGoogleCnt++;
					setTimeout($.proxy(this.drawMapMarkers, this), 500);
				}
			}
		},

		drawLocation: function( latlng, title, description ){

			var marker = new google.maps.Marker({
				position: latlng,
				title: title,
				icon: this.markerPinImage,
				map: this.map
			});

			this.mapBounds.extend(marker.position);
			google.maps.event.addListener(marker, 'click', $.proxy(this.handleMarkerClicked, this));
			this.mapmarkers.push({ marker: marker, infoWindowContent: description.replace(new RegExp('\r?\n','g'), '<br />') });
			// you have to do this everytime, cause geolockups are asynchronous
			this.map.fitBounds(this.mapBounds);
		},

		clearMapMarkers: function(){
			var markerItem;
			if( this.map && this.mapmarkers.length ){
				while(this.mapmarkers.length){
					markerItem = this.mapmarkers.pop();
					google.maps.event.clearInstanceListeners(markerItem.marker);
					markerItem.marker.setMap(null);
				}
			}

			this.mapBounds = new google.maps.LatLngBounds();
			this.mapmarkers = [];
		},

		geolockup: function( locationData ){
			var mod = this;
			mod.geocoder.geocode( { 'address': locationData.address }, function(results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					mod.drawLocation(results[0].geometry.location, locationData.title, locationData.description);
				}
			});
		},

		handleMarkerClicked: function(event){
			this.mapInfoWindow.close();
			this.mapInfoWindow.setOptions({
				content: this.getDescriptionFromLatLng(event.latLng),
				pixelOffset: new google.maps.Size(0, -(this.markerPinImageHeight + 5))
			});
			this.mapInfoWindow.setPosition(event.latLng);
			this.mapInfoWindow.open(this.map);
		},

		getDescriptionFromLatLng: function( latlng ){
			var i, length, markerItem, description = '';
			for( i = 0, length = this.mapmarkers.length; i < length; i++){
				markerItem = this.mapmarkers[i];
				if(latlng.equals(markerItem.marker.position)) {
					description = "<div class=\"googleMapsInfoWindowContentWrapper\">"+markerItem.infoWindowContent+"</div>";
					break;
				}
			}

			return description;
		},

		getMarkerFromLatLng: function( lat, lng ){
			var i, length,
				latlng = new google.maps.LatLng(lat, lng),
				markerItem = null;

			for( i = 0, length = this.mapmarkers.length; i < length; i++){
				markerItem = this.mapmarkers[i];
				if(latlng.equals(markerItem.marker.position)) {
					break;
				}
			}

			return markerItem;
		},

		onGoogleMapLoaded: function(){
			this.initializeMap();
		},

		/**
		 * Channel Call Handler.
		 * Expects an Array with location Objects in data.locations as follows:
		 *
		 * data.locations = [
		 *						{title: (String), locationlat: (Float), locationlng: (Float), description: (String), address: (String)},
		 *						...
		 * 					]
		 *
		 * @param data
		 */
		onGoogleMapDrawLocations: function(data){
			this.initGoolgeMapModule();
			this.locations = data.locations;
			this.drawMapMarkers();
		},

		/**
		 * Resizes the google map container to the parent container with potentially changed dimensions.
		 * The data attribute may have a new mapcenter position. (which should be an object of {lat: (float), lng: (float) }
		 * @param data
		 */
		onGoogleMapShowMap: function(data) {
			this.initGoolgeMapModule();
			google.maps.event.trigger(this.map, 'resize');
			this.map.fitBounds(this.mapBounds);

			if( data.mapcenter ) {
				this.map.setCenter(data.mapcenter);
				var marker = this.getMarkerFromLatLng( data.mapcenter.lat, data.mapcenter.lng );

				if( marker.marker ){
					google.maps.event.trigger(marker.marker, 'click', { latLng: marker.marker.position });
				}
			}
		},

		initGoolgeMapModule: function() {
			if ( this.initialiazed == false ) {
				if((typeof(window.google) === 'undefined' || typeof(window.google.maps) === 'undefined')) {
					if(!Tc.Module.GoogleMaps.globalMapsLibIsLoading){
						Tc.Module.GoogleMaps.globalMapsLibIsLoading = true;
						this.loadMap();
					}
					else {
						// do nothing and wait for a call on the channel.
					}
				}
				else {
					this.initializeMap();
				}
				this.initialiazed = true;
			}
		}
	});
}(window.Tc.$));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.GoogleMaps.js
// module id = 327
// module chunks = 0